import axios from "../utils/axios";

export const getTestimonialSection = async () => {
    const response = await axios.get("/settings/testimonials-page");
    return response.data;
};

export const updateTestimonialSection = async (data) => {
    const response = await axios.put("/settings/testimonials-page", data);
    return response.data;
};
